// MobiRoute Customers - FBS Integration

import React, { useEffect, useState } from 'react';
import { Button as DxButton } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import { useCustomers } from '../hooks/useCustomers';
import { getAppToken } from '../../../api/sessions';
import ThemeSettingsFromApi from '../../../theme/grid-style';
import CustomDataGrid from './CustomDataGrid';
import { useTranslation } from "react-i18next";



export const Customers: React.FC = () => {
  const {
    customers,
    loading,
    geocodingProgress,
    loadCustomers,
  } = useCustomers();
  const { t } = useTranslation();
  // Selection state
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);

  // Tarih filtreleri
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  // Geçersiz koordinatlı müşterileri ele
  const isValidCoord = (c: any) => {
    const lat = c?.lat;
    const lon = c?.lon;
    return Number.isFinite(lat) && Number.isFinite(lon) && lat !== 0 && lon !== 0;
  };
  const validCustomers = (customers || []).filter(isValidCoord);

  // Handlers
  const handleRefresh = () => {
    if (!startDate || !endDate) {
      alert('Lütfen tarih aralığı seçin');
      return;
    }
    const start = startDate.toISOString().split('T')[0];
    const end = endDate.toISOString().split('T')[0];
    loadCustomers(start, end);
  };

  const handleDelete = (keys: any[]) => {
    console.log('Sil:', keys);
    setSelectedRowKeys([]);
    // TODO: Silme işlemi
  };

  const handleExport = (type: string, format: string) => {
    console.log('Export:', type, format);
    // TODO: Export işlemi
  };

  const handleAddNew = () => {
    console.log('Yeni ekle');
    // TODO: Yeni kayıt ekleme
  };

  const handleStatusFilter = (status: string) => {
    console.log('Durum filtresi:', status);
    // TODO: Durum filtreleme işlemi
  };

  // Grid columns
  const columns = [
    {
      dataField: 'status',
      caption: t('status'),
      width: 80,
      cellRender: () => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#03A9F4',
            display: 'inline-block'
          }}></span>
          <span style={{ fontSize: '11px', color: '#03A9F4', fontWeight: '500' }}>Aktif</span>
        </div>
      )
    },
    {
      dataField: 'name',
      caption: 'Kullanıcı Adı',
      dataType: 'string' as const,
      width: 200,
    },
    {
      dataField: 'salesPerson',
      caption: 'Satış Personeli',
      dataType: 'string' as const,
      width: 160,
    },
    {
      dataField: 'companyNumber',
      caption: 'Firma Numarası',
      dataType: 'number' as const,
      width: 150,
    },
    {
      dataField: 'salesPersonnel',
      caption: 'Satış Personeli Kodu',
      dataType: 'string' as const,
      width: 180,
    }
  ];

  // Export options
  const exportOptions = [
    { id: 1, text: 'Seçilenleri Excel\'e Aktar', icon: 'exportxlsx' },
    { id: 2, text: 'Tümünü Excel\'e Aktar', icon: 'exportxlsx' },
    { id: 3, text: 'Seçilenleri PDF\'e Aktar', icon: 'exportpdf' },
    { id: 4, text: 'Tümünü PDF\'e Aktar', icon: 'exportpdf' }
  ];

  // Status filter options
  const statusFilterOptions = [
    { id: 1, text: 'Tümü' },
    { id: 2, text: 'Aktif' },
    { id: 3, text: 'Pasif' }
  ];

  // Check if user is authenticated using appToken
  const authToken = getAppToken();
  if (!authToken) {
    return (
      <>
        <ThemeSettingsFromApi />
        <div className="layout-content-wrapper">
          <div className="dx-card auth-card">
            <i className="pi pi-key auth-icon"></i>
            <h2 className="auth-title">Authentication Required</h2>
            <p className="auth-description">
              Please login to access customer data
            </p>
            <DxButton
              text="Go to Login"
              icon="user"
              type="default"
              onClick={() => window.location.href = '/login'}
            />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <ThemeSettingsFromApi />
      <div className="view crm-contact-list">
        <div className="view-wrapper view-wrapper-contact-list customers-view-wrapper">
          <div className="customers-content">
          {loading ? (
            <LoadPanel
              visible={true}
              showIndicator={true}
              showPane={true}
              message={
                geocodingProgress > 0 && geocodingProgress < 100
                  ? `Koordinatlar alınıyor... ${geocodingProgress}%`
                  : 'Müşteriler yükleniyor...'
              }
            />
          ) : (
            <CustomDataGrid
              data={validCustomers}
              columns={columns}
              selectedRowKeys={selectedRowKeys}
              onSelectionChanged={setSelectedRowKeys}
              searchPlaceholder="Ara..."
              dateFilters={[
                { value: startDate, onValueChanged: setStartDate },
                { value: endDate, onValueChanged: setEndDate }
              ]}
              onRefresh={handleRefresh}
              onAddNew={handleAddNew}
              onDelete={handleDelete}
              onExport={handleExport}
              onStatusFilter={handleStatusFilter}
              exportOptions={exportOptions}
              exportEnabled={true}
              statusFilterText="Aktif"
              statusFilterOptions={statusFilterOptions}
            />
            
            
        )}
        </div>
      </div>
    </div>
    </>
  );
};

export default Customers;